const academicsData = [
  {
    level: "Secondary Education",
    institution: "Bishnupur High School",
    year: "2015 - 2021",
    images: [
      {
        src: "/images/bhs3.gif",
        cardClass: "card1 firstcard1",
      },
    ],
  },
  {
    level: "Higher Secondary Education",
    institution: "Bishnupur High School",
    year: "2021 - 2023",
    images: [
      {
        src: "/images/bhs2.jpg",
        cardClass: "card2 secondcard2",
      },
      {
        src: "/images/bhs1.gif",
        cardClass: "card3 firstcard3",
      },
    ],
  },
  {
    level: "B.Tech in Information Technology",
    institution: "IIEST Shibpur",
    year: "2023 - 2027",
    images: [
      {
        src: "/images/iiest1.jpeg",
        cardClass: "card3 secondcard3",
      },
      {
        src: "/images/iiest4.jpeg",
        cardClass: "card1 secondcard1",
      },
      {
        src: "/images/iiest6.jpeg",
        cardClass: "card2 thirdcard2",
      },
    ],
  },
];

export default academicsData;
